mutation ValidatePassword($password: String!) {
  validatePassword(password: $password) {
    valid
    errors
  }
}
